// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
._1fvdglyw button:not([disabled]):after{border:none}._1e0c1txw{display:flex}
._u5f3v77o{padding-right:var(--ds-space-025,2px)}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/editor-common/dist/esm/ui/Toolbar/DropdownTriggerWrapper.compiled.css"],"names":[],"mappings":";AACA,wCAAwC,WAAW,CAAC,WAAW,YAAY;AAC3E,WAAW,qCAAqC","sourcesContent":["\n._1fvdglyw button:not([disabled]):after{border:none}._1e0c1txw{display:flex}\n._u5f3v77o{padding-right:var(--ds-space-025,2px)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
